export function prepareDescription({ title, t }): string {
  return t(
    '{{title}} bei ABOUT YOU bestellen. ✓Versandkostenfrei ✓Zahlung auf Rechnung ✓kostenlose Retoure',
    {
      title,
      interpolation: { escapeValue: false },
    },
  )
}
